import React from "react";

export default function EmptyState({ title, subtitle, image }) {
  return (
    <div
      className="flex flex-col items-center text-center py-16 md:py-24"
      data-testid="empty-state"
    >
      {image && (
        <div className="relative w-full max-w-2xl mb-8 overflow-hidden border-2 border-[#111111]">
          <img
            src={image}
            alt=""
            className="w-full h-56 md:h-72 object-cover grayscale opacity-80"
          />
          <div className="absolute inset-0 bg-[#F6F6F4]/30" />
        </div>
      )}
      <h2 className="font-display uppercase font-black text-3xl md:text-5xl tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 max-w-md text-[#555555] text-sm uppercase tracking-[0.2em] font-bold">
          {subtitle}
        </p>
      )}
    </div>
  );
}
